export enum AuthProvider {
  GITHUB = "GITHUB",
  GOOGLE = "GOOGLE",
  LOCAL = "LOCAL"
}
